const getMonth = (index) => KROWN.settings.locales[['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'][index]];
// get midnight date for correct date calculation
const getMidnightDate = (date) => {
  const pattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?(?:Z|[+-]\d{2}:\d{2})$/; // ISO format for dates regex
  const userTimezoneOffset = new Date().getTimezoneOffset() * 60 * 1000;

  if (date) {
    if (pattern.test(date)) {
      // create timezone adjusted date from param and strip time info
      return new Date(new Date(new Date(date).getTime() + userTimezoneOffset).setHours(0, 0, 0, 0));
    } else {
      // date is not in ISO format so no time info present, hence timezone adjustment not needed
      return new Date(new Date(new Date(date).getTime()).setHours(0, 0, 0, 0));
    }
  } else {
    // create new timezone adjusted date and strip time info
    return new Date(new Date(new Date().getTime() + userTimezoneOffset).setHours(0, 0, 0, 0));
  }
};

// Format date object to ISO string format (YYYY-M-D T00:00:00.000Z) to prevent timezone shift
const formatDateToISO = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).toString().padStart(2, '0');
  const day = String(date.getDate()).toString().padStart(2, '0');
  return `${year}-${month}-${day}T00:00:00.000Z`;
};

const _formatMoney= (cents, format) => {

  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  // const formatString = format| moneyFormat;
  const formatString = format;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number === null) {
      return 0;
    }

    number = (Math.round(number) / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      '$1' + thousands
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'");
      break;
  }

  return formatString.replace(placeholderRegex, value);

}

/*
* Get the `checkout_url` from the URL query parameter, if it exists.
* (It only ever exists on the /account/login page)
*/
function getCheckoutUrl() {  
  function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }
  return getParameterByName('checkout_url');
}

/** Clears purchase-login redirect flags (guest checkout → login flow). */
function clearPurchaseRedirectLocalStorage() {
  try {
    localStorage.removeItem('redirect_checkout');
    localStorage.removeItem('redirect_checkout_purchase_banner');
    localStorage.removeItem('redirect_checkout_login_submit');
  } catch (e) {}
}

if (typeof window !== 'undefined') {
  window.clearPurchaseRedirectLocalStorage = clearPurchaseRedirectLocalStorage;

  (function initPurchaseRedirectCleanup() {
    try {
      var p = window.location.pathname || '';
      if (/\/checkout(\/|$)/.test(p)) {
        clearPurchaseRedirectLocalStorage();
      }
    } catch (e) {}

    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || form.id !== 'cart') return;
        var sub = e.submitter;
        if (sub && sub.getAttribute('name') === 'checkout') {
          clearPurchaseRedirectLocalStorage();
        }
      },
      true
    );
  })();
}

/*
* removing hsf child attributes during cart clear
*/
function updateAndRemoveHsfAttributes() {
  const body = {
      attributes: {
        hsfChildDetails: null
      }
    }

  if (window.JPCartService) {
    return window.JPCartService.update(body);
  }

  return fetch(KROWN.settings.routes.cart_update_url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/javascript",
    },
    body: JSON.stringify(body),
  })
}

/*
 * Partner UTM on the cart:
 *  - Share-cart landing (?cart_token= + optional utm=qr|downloadqr)
 *  - Chat token (_chatToken)
 * Overwrite existing UTM values that do not already match.
 */
(function syncPartnerUtmAttributes() {
  if (typeof window === 'undefined') return;
  if (window.Shopify && window.Shopify.designMode) return;

  const CHAT_TOKEN_KEY = '_chatToken';
  const UTM_SOURCE_VALUE = 'partner';
  const CHAT_MEDIUM_VALUE = 'chat';
  const SHARE_CART_MEDIUM = 'shared_cart';
  const SHARE_CART_QR_MEDIUM = 'shared_cart_qr';
  const SHARE_CART_QR_DOWNLOAD_MEDIUM = 'shared_cart_qr_download';
  const normalize = (value) => String(value == null ? '' : value).trim();

  const resolveShareCartUtm = () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const token = normalize(params.get('cart_token'));
      if (!token) return null;
      const utm = normalize(params.get('utm')).toLowerCase();
      let medium = SHARE_CART_MEDIUM;
      if (utm === 'qr') medium = SHARE_CART_QR_MEDIUM;
      if (utm === 'downloadqr') medium = SHARE_CART_QR_DOWNLOAD_MEDIUM;
      return {
        utm_source: UTM_SOURCE_VALUE,
        utm_medium: medium,
        utm_campaign: token
      };
    } catch (e) {
      return null;
    }
  };

  const resolveChatUtm = (attrs) => {
    const token = normalize(attrs && attrs[CHAT_TOKEN_KEY]);
    if (!token) return null;
    return {
      utm_source: UTM_SOURCE_VALUE,
      utm_medium: CHAT_MEDIUM_VALUE,
      utm_campaign: token
    };
  };

  const needsUtmUpdate = (attrs, next) => {
    if (!attrs || typeof attrs !== 'object') return true;
    return (
      normalize(attrs.utm_source) !== next.utm_source ||
      normalize(attrs.utm_medium) !== next.utm_medium ||
      normalize(attrs.utm_campaign) !== next.utm_campaign
    );
  };

  const writeUtmAttributes = async (next) => {
    const payload = { attributes: next };
    if (window.JPCartService && typeof window.JPCartService.update === 'function') {
      await window.JPCartService.update(payload);
      return;
    }
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    await fetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
  };

  const applyFromCart = async (cart) => {
    const attrs = (cart && cart.attributes) || {};
    const next = resolveShareCartUtm() || resolveChatUtm(attrs);
    if (!next) return;
    if (!needsUtmUpdate(attrs, next)) return;
    await writeUtmAttributes(next);
  };

  const sync = async (cart) => {
    try {
      if (cart) {
        await applyFromCart(cart);
        return;
      }
      if (typeof window.awaitSharedCartRestore === 'function') {
        await window.awaitSharedCartRestore();
      }
      if (window.JPCartService && typeof window.JPCartService.getCart === 'function') {
        await applyFromCart(await window.JPCartService.getCart());
        return;
      }
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(root + 'cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      await applyFromCart(await response.json());
    } catch (e) {}
  };

  sync();

  if (window.JPCartService && typeof window.JPCartService.onChange === 'function') {
    window.JPCartService.onChange(function (cart) {
      sync(cart);
    });
  }
})();
